import { PageParams } from '@front-app/services/NoteApi/NoteApi';
import { NoteSortDirection } from '@front-app/services/NoteApi/NoteModels';

export const getDeeplinkPageParams = (fromMessageId: string): PageParams => ({
	fromMessageId,
	beforeLimit: 22,
	afterLimit: 23,
	sortDirection: NoteSortDirection.ASC,
});
